// @flow
import React from 'react';
import { Trans } from 'react-i18next';

import Link from 'app/common/lib/link';
import Nope from 'app/components/common/Nope';


type Props = {
  studentId: string,
}

const RestrictIdentifier = ({ studentId }: Props) => {
  return (
    <Nope
      text={(
        <Trans i18nKey="cafeteria:restrict_message_identifier">
          {'Имеется неоплаченный идентификатор. Проверьте статус идентификатора в разделе «'}
          <Link to={`/identifiers/${studentId}`}>
            {'Идентификаторы'}
          </Link>
          {'».'}
        </Trans>
      )}
    />
  );
};

export default RestrictIdentifier;
